/**********************************************
 * @name option-selects
 * @description quick add form variant selector
 **********************************************/
if (!customElements.get('option-selects')) {
  customElements.define(
    'option-selects',
    class OptionSelects extends HTMLElement {
      constructor() {
        super()
      }

      get selectedOptionValues() {
        const options = {}
        this.querySelectorAll('input:checked').forEach((node, index) => {
          const newIndex = index + 1
          const optionName = 'option' + newIndex
          options[optionName] = node.value
        })
        return options
      }

      getSelectedVariant() {
        const options = this.selectedOptionValues
        const productId = this.dataset.productId
        const activeVariants = productVariants[productId]['variants']

        activeVariants.forEach(variant => {
          let correctVariant = true
          for (const key in options) {
            if (variant[key] !== options[key]) {
              correctVariant = false
              continue
            }
          }
          if (correctVariant) {
            productVariants[productId]['activeVariant'] = variant
          }
        })

        return productVariants[productId]['activeVariant']
      }

      connectedCallback() {
        this.productId = this.dataset.productId
        this.addEventListener('change', () => {
          const activeVariant = this.getSelectedVariant()
          const activeVariantPrice = (activeVariant.price / 100.0).toFixed(0)
          const activeVariantComparePrice = (activeVariant.compare_at_price / 100.0).toFixed(0)
          const activeVariantSavePrice = activeVariantComparePrice - activeVariantPrice
          this.parentElement.querySelector('.price_tag_wrapper').querySelector('.price_tag_final').innerHTML = `€${activeVariantPrice}`
          this.parentElement.querySelector('.price_tag_wrapper').querySelector('.price_tag_compare').innerHTML = `€${activeVariantComparePrice}`
          this.parentElement.querySelector('.price_tag_wrapper').querySelector('.price_tag__save').innerHTML = `SAVE €${activeVariantSavePrice}`
          this.closest('.swiper-slide').querySelector('quick-add-form input[name="id"]').value = activeVariant.id
        })
      }
    }
  )
}

/**********************************************
 * @name quick-add-form
 * @description quickly product to the cart
 **********************************************/
if (!customElements.get('quick-add-form')) {
  customElements.define(
    'quick-add-form',
    class QuickAddForm extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.btnSubmit = this.querySelector('button')
 
        this.btnSubmit.addEventListener('click', e => {
          const targetElement = e.currentTarget
          // show loading icon...
          targetElement.innerHTML = `
            <div class="loading__spinner">
              <svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
          `

          const variantId = parseFloat(this.querySelector('input[name="id"]').value)
          const formData = {
            'items': [{
              'id': variantId,
              'quantity': 1,
            }]
          }

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            fetch('/?sections=header')
            .then((res) => res.json())
            .then((res) => {
              // update slider cart items section
              const parser = new DOMParser()
              const doc = parser.parseFromString(res['header'], 'text/html')
              document.querySelector('.shopping_cart .product_actions').innerHTML = doc.querySelector('.shopping_cart .product_actions').innerHTML
              document.querySelector('.shopping_cart .cart__drawer__items').innerHTML = doc.querySelector('.shopping_cart .cart__drawer__items').innerHTML
              document.querySelector('.shopping_cart').classList.toggle('modal_show')
              targetElement.innerHTML = `
                <img src="//www.mijnboxspring.nl/cdn/shop/t/34/assets/plus-2.svg?v=13226124297338197221766385910" class="w-[18px]" width="auto" height="auto" alt="plus-2">
              `
            })

            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              const totalPrice = cart.total_price;
              updateInstallmentPrice(totalPrice);
            });
          })
          .catch((error) => {
            console.error('Error:', error)
          })
        })
      }
    }
  )
}

/**********************************************
 * @name seller-slider
 * @description swiper based seller slider
 **********************************************/
let sellerSlider = null

const initSellerSlider = () => {
  const container = document.querySelector('.seller_slider')
  if (!container) return

  // Destroy existing instance safely
  if (sellerSlider && sellerSlider.destroy) {
    try { sellerSlider.destroy(true, true) } catch (e) { console.error('Error:', error) }
    sellerSlider = null
  }

  sellerSlider = new Swiper(container, {
    slidesPerView: 4,
    spaceBetween: 24,
    loop: false,
    pagination: {
      el: '.seller_slider .swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    navigation: {
      nextEl: '.seller_slider_wrapper .swiper--button-next',
      prevEl: '.seller_slider_wrapper .swiper--button-prev',
    },
    breakpoints: {
      0: { slidesPerView: 1.1, spaceBetween: 12 },
      575: { slidesPerView: 2, spaceBetween: 16 },
      768: { slidesPerView: 2, spaceBetween: 16 },
      1024: { slidesPerView: 3, spaceBetween: 24 },
      1160: { slidesPerView: 4, spaceBetween: 24 },
    },
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    on: {
      init() {
        this.update();
        setTimeout(() => this.update(), 50)
      }
    }
  })
}

document.addEventListener('DOMContentLoaded', initSellerSlider)
window.addEventListener('load', () => sellerSlider?.update())
window.addEventListener('resize', () => {
  clearTimeout(sellerSlider?.resizeTimer)
  sellerSlider.resizeTimer = setTimeout(() => sellerSlider?.update(), 150)
})

// Function to update installment display
function updateInstallmentPrice(totalPrice) {
  FoxTheme.Currency = (function () {
    const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  document.querySelector('.cart-installment3-price').textContent = 'of 3 x ' + FoxTheme.Currency.formatMoney(Math.trunc(totalPrice * 100) / 300, FoxTheme.settings.moneyFormat);
  document.querySelector('.cart-installment60-price').textContent = 'Vanaf ' + FoxTheme.Currency.formatMoney((totalPrice / 60).toFixed(0), FoxTheme.settings.moneyFormat) + ' p/m';

  document.querySelector('.cart-installment3').textContent = FoxTheme.Currency.formatMoney(Math.trunc(totalPrice * 100) / 300, FoxTheme.settings.moneyFormat);
  document.querySelector('.cart-installment60').textContent = FoxTheme.Currency.formatMoney((totalPrice / 60).toFixed(0), FoxTheme.settings.moneyFormat);
  document.querySelector('.cart-installment60-table').innerHTML = `
    <table cellpadding="0" cellspacing="0" style="width: 100%; text-align: center; background: #EAF7F3; border-radius: 0.6rem; border-spacing: 0.5rem; overflow: hidden;">
      <tr>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>12 keer</strong><br><span class="product-table-installment-12">${FoxTheme.Currency.formatMoney((totalPrice / 12).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>18 keer</strong><br><span class="product-table-installment-18">${FoxTheme.Currency.formatMoney((totalPrice / 18).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>24 keer</strong><br><span class="product-table-installment-24">${FoxTheme.Currency.formatMoney((totalPrice / 24).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>36 keer</strong><br><span class="product-table-installment-36">${FoxTheme.Currency.formatMoney((totalPrice / 36).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
          <td style="border: 1px solid #E5E7Eb; padding: 10px 0;"><strong>60 keer</strong><br><span class="product-table-installment-60">${FoxTheme.Currency.formatMoney((totalPrice / 60).toFixed(0), FoxTheme.settings.moneyFormat)}</span></td>
      </tr>
    </table>
  `;
}
